import { Link } from 'react-router-dom';

export default function Logo({ linkTo = '/', size = 'base' }) {
  const sizes = {
    sm: 'text-base',
    base: 'text-lg',
    lg: 'text-2xl',
  };

  return (
    <Link to={linkTo} className={`${sizes[size]} font-bold tracking-tight`}>
      <span className="text-slate-900 dark:text-white">Desp</span>
      <span className="text-blue-600">Easy</span>
    </Link>
  );
}
